import React, { useState } from "react";
import { DatePicker, Select } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Option } = Select;

const predefinedRanges = [

  { label: "Today", days: 0 },
  { label: "Yesterday", days: 1 },
  { label: "Last 3 Days", days: 3 },
  { label: "Last 5 Days", days: 5 },
  { label: "Last 7 Days", days: 7 },
  { label: "Last 15 Days", days: 15 },
  { label: "Last Month", days: 30 },
];

const DateFilter = ({ onDateChange , selectDateRange }) => {
  const [dateRange, setDateRange] = useState({fromDate : "", toDate : ""});

  const handleRangeSelect = (days) => {
    if (days === undefined) {
      setDateRange({ fromDate: "", toDate: "" });
      onDateChange([]);
      selectDateRange({ fromDate: "", toDate: "" });
      return;
    }
    const startDate = moment().subtract(days, "days").startOf("day");
    const endDate = moment().endOf("day");
    setDateRange({ fromDate: startDate, toDate: endDate });
    onDateChange([startDate, endDate]);
    selectDateRange({ fromDate: startDate, toDate: endDate });
  };

  const handleCustomDateChange = (dates) => {
    // //console.log(dates , "kamal jeet")  
    setDateRange({fromDate:dates[0], toDate:dates[1]}); 
    onDateChange(dates);
  };

  return (
    <div className="flex items-center gap-2 mb-2">
      <Select
        className="w-40"
        placeholder="Select Range"
        onChange={handleRangeSelect}
        allowClear
      >
        {predefinedRanges.map((range) => (
          <Option key={range.label} value={range.days}>
            {range.label}
          </Option>
        ))}
      </Select>
{/* <RangePicker
  className="w-60"
  showTime
  value={[dateRange.fromDate ? moment(dateRange.fromDate) : null, dateRange.toDate ? moment(dateRange.toDate) : null]}
  onChange={handleCustomDateChange}
  placeholder={["Start Date", "End Date"]}
/> */}
    </div>
  );
};

export default DateFilter;
